import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Inject, Injectable, NgModule } from '@angular/core';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i2 from '@rhinosaas/reb-ngx/reb-ngx-icon';
import { RebNgxIconConfused, RebNgxIconError, RebNgxIconIdea, RebNgxIconRocks, RebNgxIconXClose, RebNgxIconModule } from '@rhinosaas/reb-ngx/reb-ngx-icon';
import * as i3 from '@rhinosaas/reb-ngx/reb-ngx-label';
import { RebNgxLabelModule } from '@rhinosaas/reb-ngx/reb-ngx-label';
import * as i4 from '@rhinosaas/reb-ngx/reb-ngx-mat-button-icon';
import { RebNgxMatButtonIconModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-button-icon';

class RebNgxSnackMessageComponent {
    constructor(data, snackBarRef, rebNgxIconsRegistry) {
        this.data = data;
        this.snackBarRef = snackBarRef;
        this.rebNgxIconsRegistry = rebNgxIconsRegistry;
        this.closeButton = false;
        this.icoImage = '';
        /**
         * Constant that indicate the label color
         */
        this.labelColor = '#454F59';
        /**
         * Message to show
         *
         * @required
         */
        this.message = '';
        /**
         * The message's mood :)
         *
         * @required
         */
        this.mood = 'default';
        rebNgxIconsRegistry.registerIcons([
            RebNgxIconConfused,
            RebNgxIconError,
            RebNgxIconIdea,
            RebNgxIconRocks,
            RebNgxIconXClose
        ]);
    }
    ngOnInit() {
        this.setIcoMessage();
        this.setMessage();
        this.setMood();
        this.setCloseButton();
    }
    setIcoMessage() {
        switch (this.data.mood) {
            case 'success':
                this.icoImage = 'ico-rocks';
                break;
            case 'info':
                this.icoImage = 'ico-idea';
                break;
            case 'error':
                this.icoImage = 'ico-error';
                break;
            case 'default':
                this.icoImage = 'ico-rocks';
                break;
        }
    }
    setMessage() {
        var _a;
        this.message = ((_a = this.data) === null || _a === void 0 ? void 0 : _a.message) ? this.data.message : '';
    }
    setMood() {
        var _a;
        this.mood = ((_a = this.data) === null || _a === void 0 ? void 0 : _a.mood) ? this.data.mood : 'default';
    }
    setCloseButton() {
        var _a;
        this.closeButton = ((_a = this.data) === null || _a === void 0 ? void 0 : _a.closeButton) ? this.data.closeButton : false;
    }
    get classes() {
        return [`rn-reb-snackbar--${this.mood}`];
    }
}
RebNgxSnackMessageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxSnackMessageComponent, deps: [{ token: MAT_SNACK_BAR_DATA }, { token: i1.MatSnackBarRef }, { token: i2.RebNgxIconsRegistry }], target: i0.ɵɵFactoryTarget.Component });
RebNgxSnackMessageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.10", type: RebNgxSnackMessageComponent, selector: "reb-ngx-snack-message", ngImport: i0, template: "<div class=\"rn-reb-snackbar\" [ngClass]=\"classes\">\n  <div class=\"rn-reb-snackbar-body\">\n    <div class=\"rn-reb-snackbar-body-inner\">\n      <div class=\"rn-reb-snackbar-ico\">\n        <reb-ngx-icon\n          borderRadius=\"sm\"\n          [hasBackground]=\"true\"\n          [mood]=\"mood\"\n          [name]=\"icoImage\"\n          size=\"medium\"\n          spacing=\"4\"\n        ></reb-ngx-icon>\n      </div>\n      <div class=\"rn-reb-snackbar-message\">\n        <reb-ngx-label\n          class=\"reb-ngx-label\"\n          size=\"16\"\n          weight=\"400\"\n          [color]=\"labelColor\"\n          >{{ message }}\n        </reb-ngx-label>\n      </div>\n      <reb-ngx-mat-button-icon\n        *ngIf=\"closeButton\"\n        class=\"rn-reb-snackbar-action\"\n        icon=\"ico-x-close\"\n        kind=\"text\"\n        [mood]=\"mood\"\n        size=\"small\"\n        (clickHandler)=\"snackBarRef.dismiss()\"\n      >\n      </reb-ngx-mat-button-icon>\n    </div>\n  </div>\n</div>\n", styles: [".rn-reb-snackbar{border-radius:var(--border-radius-4);min-height:68px}.rn-reb-snackbar .rn-reb-snackbar-body{align-items:flex-start;display:flex;padding:var(--spacing-16) var(--spacing-48)}.rn-reb-snackbar .rn-reb-snackbar-body .rn-reb-snackbar-body-inner{align-items:center;display:flex;flex:1 100%}.rn-reb-snackbar .rn-reb-snackbar-body .rn-reb-snackbar-body-inner .rn-reb-snackbar-action{margin-left:var(--spacing-16);padding:var(--spacing-none)}.rn-reb-snackbar .rn-reb-snackbar-body .rn-reb-snackbar-body-inner .rn-reb-snackbar-ico{margin-right:var(--spacing-16)}.rn-reb-snackbar .rn-reb-snackbar-body .rn-reb-snackbar-body-inner .rn-reb-snackbar-message{display:flex;flex:1;margin:var(--spacing-none)}.rn-reb-snackbar .rn-reb-snackbar-body .rn-reb-snackbar-body-inner .rn-reb-snackbar-message .reb-ngx-label{flex:1}.rn-reb-snackbar.rn-reb-snackbar--default{background-color:var(--palette-grey-100)}.rn-reb-snackbar.rn-reb-snackbar--error{background-color:var(--palette-red-100)}.rn-reb-snackbar.rn-reb-snackbar--info{background-color:var(--palette-dark-blue-100)}.rn-reb-snackbar.rn-reb-snackbar--success{background-color:var(--palette-green-100)}.rn-reb-snackbar.rn-reb-snackbar--warning{background-color:var(--palette-orange-100)}.cdk-overlay-container .cdk-global-overlay-wrapper .cdk-overlay-pane .mat-snack-bar-container{max-width:100%;min-width:360px;padding:var(--spacing-none)}\n"], components: [{ type: i2.RebNgxIconComponent, selector: "reb-ngx-icon", inputs: ["backgroundColor", "borderRadius", "color", "hasBackground", "mood", "name", "size", "spacing"] }, { type: i3.RebNgxLabelComponent, selector: "reb-ngx-label", inputs: ["color", "mood", "size", "weight"] }, { type: i4.RebNgxMatButtonIconComponent, selector: "reb-ngx-mat-button-icon", inputs: ["disabled", "icon", "kind", "mood", "size", "type"], outputs: ["clickHandler"] }], directives: [{ type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxSnackMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'reb-ngx-snack-message', encapsulation: ViewEncapsulation.None, template: "<div class=\"rn-reb-snackbar\" [ngClass]=\"classes\">\n  <div class=\"rn-reb-snackbar-body\">\n    <div class=\"rn-reb-snackbar-body-inner\">\n      <div class=\"rn-reb-snackbar-ico\">\n        <reb-ngx-icon\n          borderRadius=\"sm\"\n          [hasBackground]=\"true\"\n          [mood]=\"mood\"\n          [name]=\"icoImage\"\n          size=\"medium\"\n          spacing=\"4\"\n        ></reb-ngx-icon>\n      </div>\n      <div class=\"rn-reb-snackbar-message\">\n        <reb-ngx-label\n          class=\"reb-ngx-label\"\n          size=\"16\"\n          weight=\"400\"\n          [color]=\"labelColor\"\n          >{{ message }}\n        </reb-ngx-label>\n      </div>\n      <reb-ngx-mat-button-icon\n        *ngIf=\"closeButton\"\n        class=\"rn-reb-snackbar-action\"\n        icon=\"ico-x-close\"\n        kind=\"text\"\n        [mood]=\"mood\"\n        size=\"small\"\n        (clickHandler)=\"snackBarRef.dismiss()\"\n      >\n      </reb-ngx-mat-button-icon>\n    </div>\n  </div>\n</div>\n", styles: [".rn-reb-snackbar{border-radius:var(--border-radius-4);min-height:68px}.rn-reb-snackbar .rn-reb-snackbar-body{align-items:flex-start;display:flex;padding:var(--spacing-16) var(--spacing-48)}.rn-reb-snackbar .rn-reb-snackbar-body .rn-reb-snackbar-body-inner{align-items:center;display:flex;flex:1 100%}.rn-reb-snackbar .rn-reb-snackbar-body .rn-reb-snackbar-body-inner .rn-reb-snackbar-action{margin-left:var(--spacing-16);padding:var(--spacing-none)}.rn-reb-snackbar .rn-reb-snackbar-body .rn-reb-snackbar-body-inner .rn-reb-snackbar-ico{margin-right:var(--spacing-16)}.rn-reb-snackbar .rn-reb-snackbar-body .rn-reb-snackbar-body-inner .rn-reb-snackbar-message{display:flex;flex:1;margin:var(--spacing-none)}.rn-reb-snackbar .rn-reb-snackbar-body .rn-reb-snackbar-body-inner .rn-reb-snackbar-message .reb-ngx-label{flex:1}.rn-reb-snackbar.rn-reb-snackbar--default{background-color:var(--palette-grey-100)}.rn-reb-snackbar.rn-reb-snackbar--error{background-color:var(--palette-red-100)}.rn-reb-snackbar.rn-reb-snackbar--info{background-color:var(--palette-dark-blue-100)}.rn-reb-snackbar.rn-reb-snackbar--success{background-color:var(--palette-green-100)}.rn-reb-snackbar.rn-reb-snackbar--warning{background-color:var(--palette-orange-100)}.cdk-overlay-container .cdk-global-overlay-wrapper .cdk-overlay-pane .mat-snack-bar-container{max-width:100%;min-width:360px;padding:var(--spacing-none)}\n"] }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_SNACK_BAR_DATA]
                    }] }, { type: i1.MatSnackBarRef }, { type: i2.RebNgxIconsRegistry }];
    } });

class RebNgxSnackbarService {
    constructor(_snackBar) {
        this._snackBar = _snackBar;
    }
    openSnackBar(body) {
        this._snackBar.openFromComponent(RebNgxSnackMessageComponent, {
            duration: body.duration,
            data: {
                mood: body.mood,
                message: body.message,
                closeButton: body.closeButton
            }
        });
    }
}
RebNgxSnackbarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxSnackbarService, deps: [{ token: i1.MatSnackBar }], target: i0.ɵɵFactoryTarget.Injectable });
RebNgxSnackbarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxSnackbarService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxSnackbarService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.MatSnackBar }]; } });

class RebNgxMatSnackBarModule {
}
RebNgxMatSnackBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxMatSnackBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RebNgxMatSnackBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxMatSnackBarModule, declarations: [RebNgxSnackMessageComponent], imports: [CommonModule,
        MatSnackBarModule,
        RebNgxLabelModule,
        RebNgxIconModule,
        RebNgxMatButtonIconModule], exports: [RebNgxSnackMessageComponent] });
RebNgxMatSnackBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxMatSnackBarModule, providers: [RebNgxSnackbarService], imports: [[
            CommonModule,
            MatSnackBarModule,
            RebNgxLabelModule,
            RebNgxIconModule,
            RebNgxMatButtonIconModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxMatSnackBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RebNgxSnackMessageComponent],
                    exports: [RebNgxSnackMessageComponent],
                    imports: [
                        CommonModule,
                        MatSnackBarModule,
                        RebNgxLabelModule,
                        RebNgxIconModule,
                        RebNgxMatButtonIconModule
                    ],
                    providers: [RebNgxSnackbarService]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RebNgxMatSnackBarModule, RebNgxSnackMessageComponent, RebNgxSnackbarService };
